/* Ferme trademark mark.
   Adds a small superscript TM after the brand word "Ferme" (any case, including
   "Ferme's") wherever it appears as visible text. "Fermeskin" is deliberately
   left alone.

   This runs in the browser because the word lives in places that cannot be
   edited through the Admin API: the header logo (sections/header.liquid is too
   large) and saved section settings in templates/index.json and product.json.
   A MutationObserver catches text that appears later (sliders, app widgets).

   Loaded on every page from the "Ferme TM" custom-liquid section in
   sections/footer-group.json. To remove the mark, delete that section. */
(function () {
  if (window.__fermeTm) return;
  window.__fermeTm = true;

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TITLE: 1, CODE: 1, PRE: 1, SVG: 1 };
  var WORD = /\bferme\b/gi;

  var css = document.createElement('style');
  css.textContent = '.ferme-tm{display:inline;font-size:.42em;line-height:0;vertical-align:super;' +
    'letter-spacing:.03em;margin-left:.1em;font-style:normal;font-weight:inherit;text-transform:uppercase;}';
  document.head.appendChild(css);

  function isMark(n) { return n && n.nodeType === 1 && n.classList && n.classList.contains('ferme-tm'); }

  function skipNode(t) {
    var p = t.parentNode;
    while (p && p !== document.body) {
      if (p.nodeType === 1) {
        if (SKIP[p.nodeName.toUpperCase()] || p.isContentEditable || isMark(p)) return true;
      }
      p = p.parentNode;
    }
    return false;
  }

  function mark(t) {
    var s = t.nodeValue;
    if (!s || s.toLowerCase().indexOf('ferme') === -1 || skipNode(t)) return;
    WORD.lastIndex = 0;
    var m, last = 0, frag = null;
    while ((m = WORD.exec(s))) {
      var end = m.index + m[0].length;
      var atEnd = end === s.length;
      if (atEnd && isMark(t.nextSibling)) continue;
      if (!frag) frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(s.slice(last, end)));
      var sp = document.createElement('span');
      sp.className = 'ferme-tm';
      sp.setAttribute('aria-hidden', 'true');
      sp.textContent = 'TM';
      frag.appendChild(sp);
      last = end;
    }
    if (!frag) return;
    frag.appendChild(document.createTextNode(s.slice(last)));
    t.parentNode.replaceChild(frag, t);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { mark(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName.toUpperCase()] || isMark(root)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [], n;
    while ((n = w.nextNode())) { if (/ferme/i.test(n.nodeValue)) list.push(n); }
    for (var i = 0; i < list.length; i++) mark(list[i]);
  }

  var queue = [], pending = false;
  function flush() {
    pending = false;
    var q = queue; queue = [];
    for (var i = 0; i < q.length; i++) { if (q[i].isConnected) scan(q[i]); }
  }

  function start() {
    scan(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var mu = muts[i];
        if (mu.type === 'characterData') queue.push(mu.target);
        else for (var j = 0; j < mu.addedNodes.length; j++) {
          var a = mu.addedNodes[j];
          if (!isMark(a)) queue.push(a);
        }
      }
      if (queue.length && !pending) { pending = true; requestAnimationFrame(flush); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
